import { config } from '../../config';

export function getMemberPreferences() {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/member-preferences`,
  };
}

export function createMemberPreference(key, value) {
  return {
    method: 'POST',
    url: `${config.core.membershipServiceUrl}/api/member-preferences`,
    data: {
      name: key,
      value: value.toString(),
    },
  };
}
export function updateMemberPreference(key, value, userId) {
  return {
    method: 'PUT',
    url: `${config.core.membershipServiceUrl}/api/member-preferences/${userId}`,
    data: {
      name: key,
      value: value.toString(),
    },
  };
}

export function getMemberDetails() {
  return {
    method: 'GET',
    url: `${config.core.membershipServiceUrl}/api/members`,
  };
}

export function updateMemberDetails({userId, changedInfo}) {
    return {
    method: 'PUT',
    url: `${config.core.membershipServiceUrl}/api/members/${userId}`,
    data: {
      id: userId,
      ...changedInfo
    },
  };
}
